import { FlexBox, FormField, FormGrid, Text } from '@dixa/lib-shared-habla';

import { FieldToggleBoxHead, ToggleBox } from 'fable/toggleBox';

import type { SettingsProps } from '../../types/settings';
import {
  WaitingTimeSettings,
  WaitingTimeSettingType,
} from '../waitingTimeSettings/waitingTimeSettings';

export function PreferredAgentSettings({
  formValues,
}: SettingsProps): JSX.Element {
  return (
    <FormGrid>
      <FormField>
        <FlexBox flexDirection="column" gap="100">
          <Text.Heading variant="heading-3">Preferred agent</Text.Heading>
          <Text.Paragraph subdued>
            Offer new conversations to the agent that has spent the most time
            helping the customer.
          </Text.Paragraph>
        </FlexBox>
      </FormField>

      <FormField>
        <ToggleBox
          title="Activate preferred agent"
          isOpen={formValues.is_preferred_agent_enabled}
          headComponent={FieldToggleBoxHead}
          textProps={{ variant: '2' }}
          input={{
            id: 'is_preferred_agent_enabled',
            value: 'is_preferred_agent_enabled',
            name: 'is_preferred_agent_enabled',
          }}
        />
      </FormField>

      {formValues.is_preferred_agent_enabled && (
        <WaitingTimeSettings
          formValues={formValues}
          type={WaitingTimeSettingType.PreferredAgent}
        />
      )}
    </FormGrid>
  );
}
